import { useEffect, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { writeReferredBy } from '../../lib/referredBy'

// /r/:code — an invite link. Stores the code (when it satisfies the code rule)
// for the account-creating POST and moves on to /discover, replacing the /r/
// entry so Back does not bounce through it. Renders nothing.
export function ReferralCapture() {
  const { code } = useParams()
  const navigate = useNavigate()
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    if (code) writeReferredBy(code)
    navigate('/discover', { replace: true })
  }, [code, navigate])

  return null
}
